import Vue from "vue";
import { $constants } from "./constants";

Vue.prototype.$constants = $constants;
